<template>
  <div>
    <button @click="toggleShow()" class="outline-none hover:text-brand-500">
      <slot />
    </button>
    <div
      class="absolute left-0 right-0 z-50 mx-4 mt-3 flex flex-col overflow-hidden whitespace-nowrap rounded bg-white pt-3 shadow sm:-mx-3"
      v-if="showMonths"
    >
      <div class="flex justify-between px-3">
        <button @click="previousYear()" class="px-2 hover:text-brand-500">
          <span class="far fa-angle-left"></span>
        </button>
        <span>{{ year }}</span>
        <button @click="nextYear()" class="px-2 hover:text-brand-500">
          <span class="far fa-angle-right"></span>
        </button>
      </div>
      <div
        class="grid gap-2 py-6 px-4"
        :class="{
          week: isWeek,
          'md:grid-cols-3': !isWeek,
          'grid-cols-3 md:grid-cols-6': isWeek,
        }"
      >
        <a
          v-for="(month, key) in months"
          :key="key"
          :href="monthLink(key)"
          v-text="month"
          class="rounded px-4 py-1 text-center text-lg"
          :class="{
            'bg-brand-500 font-semibold text-white': isCurrentMonth(key),
            'text-gray-700 hover:bg-gray-100 hover:text-black': !isCurrentMonth(key),
          }"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: {},
    url: {},
    isWeek: Boolean,
    isDay: Boolean,
  },
  data() {
    return {
      currentDate: null,
      showMonths: false,
      year: null,
    }
  },

  computed: {
    months() {
      if (this.isWeek) {
        let list = {}
        for (let i = 1; i <= moment(this.year + '-01-01').weeksInYear(); i++) {
          list[i] = i
        }

        return list
      }

      return moment.months()
    },
  },

  watch: {
    showMonths(value) {
      if (value) {
        document.addEventListener('click', this.closeIfClickedOutside)
      } else {
        document.removeEventListener('click', this.closeIfClickedOutside)
      }
    },
  },

  methods: {
    toggleShow() {
      this.showMonths = !this.showMonths
    },
    previousYear() {
      this.year -= 1
    },
    nextYear() {
      this.year += 1
    },
    monthLink(key) {
      if (this.isWeek) {
        return this.url.replace('0000/week/00', this.year + '/week/' + key)
      }

      return this.url.replace('0000/00', this.year + '/' + (key + 1))
    },
    isCurrentMonth(key) {
      if (this.isWeek) {
        return this.currentDate.year() == this.year && key == this.currentDate.isoWeek()
      }

      return this.currentDate.year() == this.year && key == this.currentDate.month()
    },
    closeIfClickedOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.showMonths = false
      }
    },
  },

  created() {
    this.currentDate = window.moment(this.current)
    this.year = this.currentDate.year()
  },
}
</script>
